import styled from "styled-components";
import { SecondaryLink } from "../SecondaryLink";
import { Icon } from "../SecondaryLink/SecondaryLink.styles";

export const Layout = styled(SecondaryLink)`
  & > ${Icon} {
    svg {
      fill: currentColor;
    }
  }
`;
